import actions from './actions';


const { 
    STORE_DASHBOARD_DATA_BEGIN, STORE_DASHBOARD_DATA_SUCCESS, STORE_DASHBOARD_DATA_ERR, 
} = actions;

const initialStateArray = { data: [], loading: false, error: null, };

const storeDashboardDataReducers = (state = initialStateArray, action) => {
    const { type, data, err } = action;
    switch (type) {
        case STORE_DASHBOARD_DATA_BEGIN:
            return {
                ...initialStateArray,
                loading: true,
            };
        case STORE_DASHBOARD_DATA_SUCCESS:
            return {
                ...initialStateArray,
                data,
                error:null,
                loading: false,
            };
        case STORE_DASHBOARD_DATA_ERR:
            return {
                ...initialStateArray,
                error: err,
                data:null,
                loading: false,
            };

        default:
            return state;
    }
};

export { 
    storeDashboardDataReducers, 
}; 